import {Button, Grid} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {EventData} from '@/types/event';
import {darkTheme} from '@/assets/styles/sjone-theme';
import {env} from '@/config';
import {useEventPermissions} from '@/services/events';

interface EventDetailsButtonsProps {
  selectedEvent: EventData;
  pastEvent: boolean;
  handleLeaveClick: () => void;
  handleEditButtonClick: () => void;
  handleCloneButtonClick: () => void;
  handleDeleteConfirmation: () => void;
  handleCancelConfirmation: () => void;
}

const EventDetailsButtons: React.FC<EventDetailsButtonsProps> = ({
  selectedEvent,
  pastEvent,
  handleLeaveClick,
  handleEditButtonClick,
  handleCloneButtonClick,
  handleDeleteConfirmation,
  handleCancelConfirmation
}) => {
  const {t} = useTranslation();

  const {APP_VARIANT} = env;

  const {
    canEditEvent,
    canCloneEvent,
    canDeleteEvent,
    canCancelEvent,
    canLeaveEvent,
    isPaidEvent,
    isUserManager
  } = useEventPermissions(selectedEvent, pastEvent);

  return (
    <Grid
      container
      spacing={3}
      sx={{
        marginTop: {
          xs: 2,
          sm: APP_VARIANT !== 'sjone' && !isUserManager ? 8 : 6
        }
      }}
    >
      {canEditEvent && (
        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={handleEditButtonClick}
            sx={{
              width: '100%'
            }}
          >
            {t('edit')}
          </Button>
        </Grid>
      )}
      {canCloneEvent && (
        <Grid item xs={12} sx={{display: 'flex', justifyContent: 'center'}}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleCloneButtonClick}
            sx={{
              width: '100%'
            }}
          >
            {t('clone')}
          </Button>
        </Grid>
      )}

      {canDeleteEvent && (
        <Grid item xs={12} sx={{display: 'flex', justifyContent: 'center'}}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleDeleteConfirmation}
            sx={{
              width: '100%'
            }}
          >
            {t('delete')}
          </Button>
        </Grid>
      )}
      {canCancelEvent && (
        <Grid item xs={12} sx={{display: 'flex', justifyContent: 'center'}}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleCancelConfirmation}
            sx={{
              width: '100%'
            }}
          >
            {t('event_cancel')}
          </Button>
        </Grid>
      )}
      {canLeaveEvent && (
        <Grid
          item
          xs={12}
          sx={{
            marginTop: {xs: 0, sm: 3},
            display: 'flex',
            justifyContent: 'center',
            mb: {xs: 1, sm: 0}
          }}
        >
          <Button
            variant="contained"
            onClick={handleLeaveClick}
            sx={{
              width: '100%',
              backgroundColor: darkTheme.palette.secondary.dark
            }}
          >
            {isPaidEvent && !isUserManager
              ? t('request_refund')
              : t('event_leave')}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default EventDetailsButtons;
